import styled from "styled-components"
import Color from "../../../style/enum/color"

export const Error = styled.div`
  color: ${Color.RED};
  font-size: 0.8rem;
  margin-top: 3px;
`
